<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        rowKey="contractNo"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import { getUserCompanyList } from '@/common/js/util';
  import COM_API from '@/api/masterData/company.js';
  import API from '@/api/financeCenter/saleInvoice.js';
  import { mapState } from 'vuex';
  export default {
    name: 'outputTaxDetails',
    mixins: [tableMixins],
    data() {
      return {
        // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']},
        query: {
          payableInvoiceCompanyCodeIn: null,
          payableInvoiceCreateDate: undefined,
          partnerCodeIn: null,
          payableInvoiceDepartmentCodeIn: null,
          salesContractNo: undefined,
          documentCode: undefined,
          invoiceStatusIn: undefined,
          transactionTypeCodeIn: null,
          salesLadingNo: undefined,
          invoiceTypeIn: undefined,
          invoiceAmountStart: null,
          invoiceAmountEnd: null,
          postDate: undefined,
          reverseDate: null,
          currency: undefined,
        },
        tableData: [],
        load: false,
        columnListDefault: [
          {
            field: 'invoiceCompanyCode',
            title: '公司代码',
            visible: true,
          },
          {
            field: 'invoiceCompanyName',
            title: '公司名称',
            visible: true,
          },
          {
            field: 'invoiceDepartmentCode',
            title: '部门代码',
            visible: true,
          },
          {
            field: 'invoiceDepartmentName',
            title: '部门名称',
            visible: true,
          },
          {
            field: 'accountingStatus',
            title: '入账状态',
            visible: true,
          },
          {
            field: 'accountedDate',
            title: '入账日期',
            visible: true,
          },
          {
            field: 'reverseDate',
            title: '冲销日期',
            visible: true,
          },
          {
            field: 'transactionTypeName',
            title: '事务处理类型名称',
            visible: true,
          },
          {
            field: 'invoiceNum',
            title: '单据编号',
            visible: true,
          },
          {
            field: 'invoiceCreatePersonName',
            title: '制单人名称',
            visible: true,
          },
          {
            field: 'invoiceCreateDate',
            title: '制单日期',
            visible: true,
          },
          {
            field: 'partnerCode',
            title: '客户编码',
            visible: true,
          },
          {
            field: 'partnerName',
            title: '客户名称',
            visible: true,
          },
          {
            field: 'currencyName',
            title: '币种',
            visible: true,
          },
          {
            field: 'exchangeType',
            title: '汇率类型',
            visible: true,
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            visible: true,
          },
          {
            field: 'exchangeDate',
            title: '汇率日期',
            visible: true,
          },
          {
            field: 'belongDate',
            title: '归属日期',
            visible: true,
          },
          {
            field: 'invoiceAmount',
            title: '发票总金额',
            visible: true,
          },
          {
            field: 'excludedTaxAmount',
            title: '发票不含税金额',
            visible: true,
          },
          {
            field: 'taxAmount',
            title: '发票税额',
            visible: true,
          },
          {
            field: 'invoiceType',
            title: '发票类型',
            visible: true,
          },
          {
            field: 'invoiceStatus',
            title: '单据状态',
            visible: true,
          },
          {
            field: 'invoiceAccountedAmount',
            title: '发票本币总金额',
            visible: true,
          },
          {
            field: 'excludedTaxAccountedAmount',
            title: '发票本币不含税金额',
            visible: true,
          },
          {
            field: 'taxAccountedAmount',
            title: '发票本币税额',
            visible: true,
          },
          {
            field: 'recoverableTaxAmount',
            title: '出口退税额',
            visible: true,
          },
          {
            field: 'differenceAmount',
            title: '发票与合同差异金额合计',
            visible: true,
          },
          {
            field: 'mark',
            title: '备注',
            visible: true,
          },
          {
            field: 'invoiceDetailCode',
            title: '销售发票行编号',
            visible: true,
          },
          {
            field: 'ladingNo',
            title: '提单号',
            visible: true,
          },
          {
            field: 'contractNo',
            title: '合同号',
            visible: true,
          },
          {
            field: 'productNo',
            title: '商品编码',
            visible: true,
          },
          {
            field: 'productDesc',
            title: '商品描述',
            visible: true,
          },
          {
            field: 'ladingQuantity',
            title: '提单数量',
            visible: true,
          },
          {
            field: 'ladingUnitPrice',
            title: '提单单价',
            visible: true,
          },
          {
            field: 'ladingAmount',
            title: '提单金额',
            visible: true,
          },
          {
            field: 'invoiceQuantity',
            title: '本次开票数量',
            visible: true,
          },
          {
            field: 'unitName',
            title: '单位',
            visible: true,
          },
          {
            field: 'invoiceUnitPrice',
            title: '含税单价',
            visible: true,
          },
          {
            field: 'invoiceAmount1',
            title: '发票总金额',
            visible: true,
          },
          {
            field: 'taxName',
            title: '税码',
            visible: true,
          },
          {
            field: 'taxRate',
            title: '税率',
            visible: true,
          },
          {
            field: 'excludedTaxAmount1',
            title: '不含税金额',
            visible: true,
          },
          {
            field: 'taxAmount1',
            title: '税额',
            visible: true,
          },
          {
            field: 'invoiceAccountedAmount1',
            title: '本币含税金额',
            visible: true,
          },
          {
            field: 'excludedTaxAccountedAmount1',
            title: '本币不含税金额',
            visible: true,
          },
          {
            field: 'taxAccountedAmount1',
            title: '本币税额',
            visible: true,
          },
          {
            field: 'ladingDifferenceAmount',
            title: '与提单差异金额',
            visible: true,
          },
          {
            field: 'recoverableTaxRate',
            title: '出口退税率',
            visible: true,
          },
          {
            field: 'recoverableTaxAmount1',
            title: '出口退税额',
            visible: true,
          },
        ],
        personList: [],
        expenseGroupList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        lang: (state) => state.lang.language,
        dict: (state) => state.dict,
      }),
      searchColumns() {
        return [
          {
            type: 'selectMultiple', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'payableInvoiceCompanyCodeIn',
            options: getUserCompanyList(),
          },
          {
            prop: 'payableInvoiceCreateDate',
            name: '制单日期',
            type: 'daterange',
          },
          {
            prop: 'partnerCodeIn',
            name: '客户',
            type: 'searchTableSpec',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              departmentCode: this.query.ladingBusinessDepartmentNoIn,
              companyCode: this.query.ladingBusinessCompanyCodeIn
                ? this.query.ladingBusinessCompanyCodeIn.join()
                : '', //公司
            },
            isNeedMultipleValue: true,
          },
          {
            prop: 'documentCode',
            name: '单据编号',
            type: 'input',
          },
          {
            prop: 'salesContractNo',
            name: '销售合同号',
            type: 'input',
          },
          {
            prop: 'payableInvoiceDepartmentCodeIn',
            name: '部门',
            type: 'treeSelect',
            apiUrl: COM_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            multiple: true,
            clearable: false,
          },
          {
            prop: 'invoiceStatusIn',
            type: 'dictSelect',
            name: '单据状态',
            apiData: { dictType: 'invoice_status' },
            multiple: true,
          },
          {
            type: 'ajaxSelect',
            name: '事务处理类型',
            prop: 'transactionTypeCodeIn',
            clearable: true,
            apiUrl: API.LIST_TRANSACTION_TYPE,
            labelKey: 'transactionTypeName',
            valueKey: 'transactionTypeCode',
            apiData: {
              transactionTypeStatus: 'Enable',
            },
            multiple: true,
            required: true,
          },
          {
            prop: 'salesLadingNo',
            name: '销售提单号',
            type: 'input',
          },
          {
            type: 'dictSelect',
            prop: 'invoiceTypeIn',
            name: '发票类型',
            apiData: { dictType: 'invoice_type' },
            multiple: true,
          },
          {
            // 制单人
            type: 'select',
            name: this.$t('receivablesManage.basicInfo.registerCreatePersonNo'),
            prop: 'payableInvoiceCreatePersonNoIn',
            options: this.personList,
            required: true,
            multiple: true,
          },
          {
            type: 'inputRange',
            prop: ['invoiceAmountStart', 'invoiceAmountEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '发票总金额',
          },
          {
            prop: 'postDate',
            name: '入账日期',
            type: 'daterange',
          },
          {
            type: 'dictSelect',
            prop: 'postStatusIn',
            name: '入账状态',
            apiData: { dictType: 'post_status' },
            multiple: true,
          },
          {
            prop: 'reverseDate',
            name: '冲销日期',
            type: 'daterange',
          },
          {
            type: 'dictSelect',
            prop: 'currency',
            name: '币种',
            apiData: { dictType: 'SCZX_currency' },
          },
        ];
      },
    },
    mounted() {
      this.getPerson();
      this.getDictList();
      this.getData();
    },
    methods: {
      getData() {
        this.load = true;
        let params = {
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
          ...this.query,
        };
        if (this.query.payableInvoiceCreateDate) {
          params.payableInvoiceCreateDateStart = this.query.payableInvoiceCreateDate[0];
          params.payableInvoiceCreateDateEnd = this.query.payableInvoiceCreateDates[1];
          delete params.payableInvoiceCreateDate;
        }
        if (this.query.partnerCodeIn) {
          params.partnerCodeIn = this.query.partnerCodeIn.map((item) => {
            return item.partnerCode;
          });
        }
        if (this.query.reverseDate) {
          params.reverseDateStart = this.query.reverseDate[0];
          params.reverseDateEnd = this.query.reverseDate[1];
          delete params.reverseDate;
        }
        if (this.query.postDate) {
          params.postDateStart = this.query.postDate[0];
          params.postDateEnd = this.query.postDate[1];
          delete params.postDate;
        }
        if (this.query.payableInvoiceDepartmentCodeIn) {
          params.payableInvoiceDepartmentCodeIn =
            this.query.payableInvoiceDepartmentCodeIn.split(',');
        }
        // if(this.query.productNoIn) {
        //   params.productNoIn = this.query.productNoIn.map(item => {return item.productDetailCode})
        // }
        this.$axios.post('/financial/payment/listOutputTaxReportByPage', params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      resetBtnClick() {
        this.getData();
      },
      async getPerson() {
        // 制单人
        let res = await this.$baseRequest.getPerson();
        if (res) {
          this.personList = res.map((item) => {
            return {
              value: item.id + '',
              label: item.personName,
            };
          });
        }
      },
      getDictList() {
        // 费用类型
        this.$baseRequest.getExpenseTypeFormat().then((res) => {
          this.expenseGroupList = res;
        });
      },
    },
  };
</script>

<style scoped></style>
